const appearStoreId = (id, value) => "".concat(id, ": ").concat(value);
export { appearStoreId };